import axios from 'axios';
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { config, SETTING_KEY } from '../../config/Config';
import { handleMessage } from '../../helper/utils';
import SelectTimeZone from './components/SelectTimeZone';
import ConfigAPIVersionMobile from './ConfigAPIVersionMobile';
import Fee from './Fee';
import LimitDisplayOrder from './Limit';
import Received from './received';
import TimeExecute from './TimeExecute';
import TimeoutCITC from './TimeoutCITC';
import TimeSetting from './TimeSetting';
import ToggleCITC from './ToggleCITC';
import ToggleMaeda from './ToggleMaeda';
import ToggleHyperpay from './ToogleHyperpay';
import ToogleODOO from './ToogleODOO';
// import ToogleShukah from './ToogleShukah';
import WhatsAppPhone from './WhatsAppPhone';
import ToggleSocket from './ToggleSocket';
import useEventEnter from '../../hooks/useEventEnter';
import ConfigAPIPaymentPlatform from './ConfigAPIPaymentPlatform';
import FeeForCasper from './FeeForCasper';
// import ConfigAPIPaymentType from './ConfigAPIPaymentType';
import ToggleMembership from './ToggleMembership';
import { DataContext } from '../../context/DataContext';

export default function TabSetting({ isSuperAdmin }) {
  const { t } = useTranslation();
  const { isCurrentDeliveryStatus, handleChangeCurrentDeliveryStatus } = useContext(DataContext);

  const [haveSetting, setHaveSetting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState(false);
  const [error, setError] = useState(false);
  const [execute, setExecute] = useState({});
  const [received, setReceived] = useState({});
  const [whatsAppPhone, setWhatsAppPhone] = useState({});
  const [fee, setFee] = useState({});
  const [feeForCasper, setFeeForCasper] = useState({});

  const [timeSetting, setTimeSetting] = useState({});
  const [citc, setCitc] = useState({});
  const [hyperpay, setHyperpay] = useState({});
  const [odoo, setOdoo] = useState({});

  const [limitOrder, setLimitOrder] = useState({});
  const [timeoutCITC, setTimeoutCITC] = useState({});

  // const [apiVerPortal, setApiVerPortal] = useState({});
  const [apiVerMobile, setApiVerMobile] = useState({});
  const [shukah, setShukah] = useState({});
  const [enableOrderSocket, setEnableOrderSocket] = useState({});
  const [enableMembership, setEnableMembership] = useState({});
  const [apiPaymentPlatform, setApiPaymentPlatform] = useState({});

  const [errors, setErrors] = useState({});

  const onSubmit = async () => {
    if (Object.values(errors).length > 0) {
      return false;
    }
    if (loading) return false;
    setLoading(true);
    try {
      const settingData = [
        {
          key: SETTING_KEY.TOGGLE_ODOO,
          content: {
            ...odoo,
          },
        },
        {
          key: SETTING_KEY.TIME_TRACKING,
          content: {
            ...timeSetting,
          },
        },
        {
          key: SETTING_KEY.TOGGLE_CITC,
          content: {
            ...citc,
          },
        },
        {
          key: SETTING_KEY.DRIVER_TIME_EXECUTE,
          content: {
            ...execute,
          },
        },
        {
          key: SETTING_KEY.RECEIVED,
          content: {
            ...received,
          },
        },
        {
          key: SETTING_KEY.WHATSAPP,
          content: {
            ...whatsAppPhone,
          },
        },
        {
          key: SETTING_KEY.LIMIT_ORDER,
          content: {
            ...limitOrder,
          },
        },
        {
          key: SETTING_KEY.HYPERPAY,
          content: {
            ...hyperpay,
          },
        },
        {
          key: SETTING_KEY.TIMEOUT_CITC,
          content: {
            ...timeoutCITC,
          },
        },
        {
          key: SETTING_KEY.TOGGLE_SHUKAH,
          content: {
            ...shukah,
          },
        },
        {
          key: SETTING_KEY.ENABLE_ORDER_SOCKET,
          content: {
            ...enableOrderSocket,
          },
        },
        {
          key: SETTING_KEY.MEMBERSHIP,
          content: {
            ...enableMembership,
          },
        },
      ];
      if (isSuperAdmin) {
        settingData.push(
          {
            key: SETTING_KEY.FEE_TAX,
            content: {
              ...fee,
            },
          },

          {
            key: SETTING_KEY.FEE_TAX_FOR_CASPER,
            content: {
              ...feeForCasper,
            },
          },

          {
            key: SETTING_KEY.API_VER_MOBILE,
            content: {
              ...apiVerMobile,
            },
          },

          {
            key: SETTING_KEY.PAYMENT_PLATFORM,
            content: {
              ...apiPaymentPlatform,
            },
          }
        );
      }
      const resp = await axios.post(
        config.API_URL.SETTING.CREATE,
        {
          data: settingData,
        },
        {
          headers: config.headers,
        }
      );
      const { data } = resp;

      if (data.status) {
        toast(t('data_saved_successfully'), { position: toast.POSITION.BOTTOM_LEFT });
        return;
      }
      toast.error(t('request_assigned_to_driver'), { position: toast.POSITION.BOTTOM_LEFT });
      return;
    } catch (errors) {
    } finally {
      setLoading(false);
    }
  };

  const handlerSetting = () => {
    if (password === process.env.REACT_APP_PASSWORD_SETTING) {
      setHaveSetting(true);
    }

    setError(true);
  };

  useEventEnter(handlerSetting);

  const handlerChange = (e) => {
    setPassword(e.target.value);
  };

  const createFakeOrder = async () => {
    if (isSuperAdmin) {
      try {
        const res = await axios.post(
          config.API_URL.ORDERS.CREATE_FAKE_ORDER,
          {},
          {
            headers: config.headers,
          }
        );

        if (res.data.status === 200) {
          handleMessage('success', t('create_fake_order_success'));
        } else {
          handleMessage('error', t('create_fake_order_failed'));
        }
      } catch (error) {
        handleMessage('error', t('data_error'));
      }
    }
  };

  const clearNotifications = async () => {
    try {
      const res = await axios.delete(config.API_URL.SETTING.CLEAR_NOTIFICATIONS, {
        headers: config.headers,
      });

      if (res.status === 204) {
        handleMessage('success', 'Clear notifications success');
      } else {
        handleMessage('error', 'Clear notifications fail');
      }
    } catch (error) {
      handleMessage('error', t('data_error'));
    }
  };

  return (
    <>
      {!haveSetting && (
        <div className="flex flex-col justify-end">
          <div className="setting">
            <p>{t('enter_password_login_to_setting')}</p>
            <div className="row flex items-center gap-x-4">
              <label>{t('password')}</label>
              <input type="password" value={execute.time} onChange={handlerChange} />
            </div>
            {error && (
              <p style={{ color: 'rgba(244, 91, 105, 1)' }}>{t('password_is_not_match')}</p>
            )}
          </div>

          <div className="setting">
            <button className="saveButton" onClick={handlerSetting}>
              {t('login')}
            </button>
          </div>
        </div>
      )}
      {haveSetting && (
        <div className="flex flex-col justify-end">
          <div>
            <div className="flex justify-between items-center px-12">
              <button
                type="button"
                className={`activation ${!isCurrentDeliveryStatus && 'disableExpress'}`}
                onClick={handleChangeCurrentDeliveryStatus}
              >
                {isCurrentDeliveryStatus ? t('active') : t('inactive')}
              </button>
              <h1 className="text-4xl  py-8 rtl">{t('الإعداد للوحة القيادة Locate Go')}</h1>
            </div>
            {isSuperAdmin && (
              <div className="setting">
                <button
                  className="refresh-button create-fake-order-button"
                  onClick={createFakeOrder}
                >
                  {t('create_fake_order')}
                </button>
                <button
                  className="refresh-button create-fake-order-button mr-10"
                  onClick={clearNotifications}
                >
                  Clear Notifications
                </button>
              </div>
            )}

            <TimeExecute setExcute={setExecute} execute={execute} />

            {isSuperAdmin && (
              <Fee fee={fee} setFee={setFee} setErrors={setErrors} errors={errors} />
            )}

            {isSuperAdmin && (
              <FeeForCasper
                feeForCasper={feeForCasper}
                setFeeForCasper={setFeeForCasper}
                setErrors={setErrors}
                errors={errors}
              />
            )}

            <TimeSetting timeSetting={timeSetting} setTimeSetting={setTimeSetting} />
            <Received setReceived={setReceived} received={received} />
            <LimitDisplayOrder setLimitOrder={setLimitOrder} limitOrder={limitOrder} />
            <WhatsAppPhone setWhatsAppPhone={setWhatsAppPhone} whatsAppPhone={whatsAppPhone} />
            <ToggleCITC setCitc={setCitc} citc={citc} />
            <ToggleHyperpay setHyperpay={setHyperpay} hyperpay={hyperpay} />
            {/* <ToogleShukah shukah={shukah} setShukah={setShukah} /> */}
            <ToogleODOO setOdoo={setOdoo} odoo={odoo} />
            <ToggleSocket
              enableOrderSocket={enableOrderSocket}
              setEnableOrderSocket={setEnableOrderSocket}
            />
            <ToggleMembership
              setEnableMembership={setEnableMembership}
              enableMembership={enableMembership}
            />

            <TimeoutCITC setTimeoutCITC={setTimeoutCITC} timeoutCITC={timeoutCITC} />
            {isSuperAdmin && (
              <div style={{ backgroundColor: 'red' }}>
                {/* <ConfigAPIVersionPortal
                  apiVerPortal={apiVerPortal}
                  setApiVerPortal={setApiVerPortal}
                /> */}
                <ConfigAPIVersionMobile
                  apiVerMobile={apiVerMobile}
                  setApiVerMobile={setApiVerMobile}
                />
              </div>
            )}
            <SelectTimeZone />

            {isSuperAdmin && (
              <div style={{ backgroundColor: 'red' }}>
                <ConfigAPIPaymentPlatform
                  apiPaymentPlatform={apiPaymentPlatform}
                  setApiPaymentPlatform={setApiPaymentPlatform}
                />
              </div>
            )}

            <div className="setting">
              <button className="saveButton" onClick={onSubmit} disabled={loading}>
                {t('save')}
              </button>
            </div>
          </div>
          <hr />
          <div>
            <h1 className="text-4xl px-12 py-8 rtl">{t('تفعيل / تعطيل حالة عمل Locate Go ')}</h1>
            <ToggleMaeda />
          </div>
        </div>
      )}
    </>
  );
}
